type SkeletonProps = {
  className?: string;
};

export function Skeleton({ className = "" }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded-lg bg-slate-800/80 ${className}`}
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/80 p-6">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="mt-5 h-10 w-24" />
      <Skeleton className="mt-5 h-3 w-full" />
      <Skeleton className="mt-3 h-3 w-2/3" />
    </div>
  );
}

export function SkeletonTable() {
  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/80 p-6">
      <Skeleton className="h-5 w-40" />

      <div className="mt-6 space-y-4">
        {Array.from({ length: 6 }).map((_, index) => (
          <div
            key={index}
            className="grid grid-cols-4 gap-4 rounded-xl border border-slate-800 bg-slate-950/60 p-4"
          >
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-4 w-16" />
          </div>
        ))}
      </div>
    </div>
  );
}